<!-- Created by Maxim B. on 20/05/20.-->
<!-- Copyright © 2020 SEVEN. All rights reserved.-->

<button matRipple class="btn" fxFlexAlign="start" [disabled]="disabled">
  <mat-icon [svgIcon]="icon"></mat-icon>
</button>
